var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.75,
    width: 45,
    height: 45,
    rx: 2.5,
    fill: "#330C00"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.75,
    width: 45,
    height: 45,
    rx: 2.5,
    stroke: "#6D4C44"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.84 36.25H10.4523V18.8904H15.84V36.25ZM13.1451 16.522C12.5257 16.5245 11.9194 16.3431 11.4029 16.0007C10.8865 15.6583 10.483 15.1703 10.2435 14.5983C10.0041 14.0264 9.93936 13.3962 10.0576 12.7875C10.1758 12.1787 10.4717 11.6187 10.9077 11.1783C11.3438 10.7379 11.9005 10.4368 12.5075 10.313C13.1145 10.1893 13.7445 10.2486 14.3179 10.4832C14.8912 10.7179 15.3822 11.1176 15.7288 11.6316C16.0753 12.1456 16.2618 12.7509 16.2648 13.3711C16.2654 14.2022 15.9378 14.9997 15.3534 15.59C14.769 16.1802 13.9752 16.5152 13.1451 16.522ZM35.9936 36.25H30.6271V27.7988C30.6271 25.7854 30.5868 23.2022 27.8281 23.2022C25.0291 23.2022 24.6002 25.3899 24.6002 27.6542V36.25H19.2146V18.8904H24.3772V21.2589H24.4515C24.9682 20.3737 25.7152 19.6456 26.6128 19.1521C27.5104 18.6586 28.525 18.4182 29.5483 18.4567C34.9976 18.4567 36 22.0498 36 26.7145V36.25H35.9936Z",
    fill: "#FFF9EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.61d6906bda4525406be3c4cd9146d2a5.svg";
export { ForwardRef as ReactComponent };